import { Mail, Calendar, User } from "lucide-react";

const EmailPreview = ({ email }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  return (
    <div className="email-preview" data-testid="email-preview">
      <div className="email-content">
        <div className="email-header">
          <h1 className="email-subject" data-testid="email-subject">
            {email.subject}
          </h1>
          <div className="email-meta">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center">
                <User className="w-4 h-4 text-slate-600" />
              </div>
              <div>
                <span className="email-sender" data-testid="email-sender-name">
                  {email.sender_name}
                </span>
                <span className="text-slate-400 mx-2">&lt;</span>
                <span data-testid="email-sender-email">{email.sender_email}</span>
                <span className="text-slate-400">&gt;</span>
              </div>
            </div>
            <div className="flex items-center gap-1 text-slate-500 ml-auto">
              <Calendar className="w-3.5 h-3.5" />
              <span className="text-xs" data-testid="email-date">
                {formatDate(email.received_at)}
              </span>
            </div>
          </div>
        </div>
        
        <div className="email-body" data-testid="email-body">
          {email.body}
        </div>
      </div>
      
      {/* Instructions panel */}
      <div className="mt-6 max-w-800 mx-auto">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Mail className="w-5 h-5 text-blue-600 mt-0.5" />
            <div>
              <h3 className="text-sm font-medium text-blue-900 mb-1">
                Mode démonstration
              </h3>
              <p className="text-xs text-blue-700">
                Cliquez sur "Analyser l'email" dans la sidebar pour extraire automatiquement les données commerciales de cet email. 
                Vous pourrez ensuite créer un contact, une opportunité ou un devis dans Sellsy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
